<template>
  <div class="user_wrap">
    <BreadCrumb crumb="图片审核"></BreadCrumb>
    <div class="top_bar">
        <el-row>
          <el-col :span="8">
            <el-input placeholder="请输入搜索内容" v-model="keyword" class="input-with-select" size="small">
              <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
            </el-input>
          </el-col>
          <el-col :span="3" :offset='10'>
            <div class="batch_operation">通过</div>
          </el-col>
          <el-col :span="1">
            <div class="export_data">驳回</div>
          </el-col>
        </el-row>
    </div>
   <ImgAuditTable :skus="aSkuList" @fnResetTable="fnGetData(1)"></ImgAuditTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddSku from '@/components/widget/AddSku'
import ImgAuditTable from '@/components/widget/ImgAuditTable'
import cons from '@/components/constant'

export default {
  name: 'UserAudit',
  data () {
    return {
      keyword:'',
      page:1,
      pages:8,
      pagesize:10,
      aSkuList:[]
    }
  },
  components:{
    BreadCrumb,
    AddSku,
    ImgAuditTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/skus/', {
          headers: {
            'Authorization': 'JWT ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            pagesize:this.pagesize,
            order_by: 'id',
            keyword:this.keyword
          }
      })
      .then(dat=>{
          this.aSkuList = dat.data.list;
          this.page = dat.data.page;
          this.pages = dat.data.pages;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetKey:function(dat){
       this.keyword = dat;
       this.fnGetData(1);
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto 10px;
  }


.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ImgAudit.vue